import { createContext } from 'react';
export const LoginModalContext = createContext(() => {});
